import React from "react";
import SwoodleUpdatedLogo from "../../../Assets/Icons/SwoodleUpdatedLogo.svg";
import person from "../../../Assets/Images/Person.svg";
import passwordIcon from "../../../Assets/Icons/passwordIcon.svg";
import emailIcon from "../../../Assets/Icons/emailIcon.svg";
import PrimaryButton from "../../common/PrimaryButton";
import TextInput from "../../common/SignUp/TextInput";
import PhoneFormInput from "../../common/PhoneInput";
import Loader from "../../common/Loader";

const MerchantAccountSetupForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
  loading = false,
  topHeading = "Welcome to Swoodle! Let's set up your Account!",
  sectionTitle = "Create Your Account",
  submitLabel = "Create Account",
  submitDisabled = false,
  showPhoneField = false,
  phoneFieldVariant = "default",
  showEmailField = false,
  emailValue = "",
  showPassword = false,
  togglePassword,
  showConfirmPassword = false,
  toggleConfirmPassword,
  hideConfirmPassword = false,
  statusContent = null,
  hideFields = false,
  showSubmitButton = true,
}) => {
  return (
    <form
      className="w-full py-10 min-h-screen flex flex-col items-center offerform"
      onSubmit={handleSubmit}
    >
      {loading && <Loader />}
      <>
        <p className="font-poppins font-[500] text-[14px] sm:text-[18px] md:text-[22px] lg:text-[26px] text-[#303030] px-4 text-center">
          {topHeading}
        </p>
        <div className="flex flex-col items-center w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] xl:w-[45%] 2xl:w-[40%]">
          <img src={SwoodleUpdatedLogo} alt="Swoodle" className="pt-[6%] pb-[2%] w-[60%]"></img>
          <p className="font-poppins font-[500] sm:text-[18px] md:text-[22px] lg:text-[26px] text-[#303030]">
            MERCHANT
          </p>
          <div className="flex flex-col justify-start items-start gap-2 w-full">
            {statusContent}
            {!hideFields && (
              <>
                <p className="font-poppins font-[500] text-[14px] sm:text-[16px] md:text-[18px] lg:text-[18px] xl:text-[22px] text-[#303030] mt-6 sm:mt-10 mb-3 text-start">
                  {sectionTitle}
                </p>
                <TextInput
                  Icon={person}
                  name={"firstName"}
                  value={values?.firstName || ""}
                  placeholder={"First Name"}
                  inputClass={
                    "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
                  }
                  iconAreaClass={
                    "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
                  }
                  innerDivClass={"h-[45px] sm:h-[55px]"}
                  inputDivClass={"h-[70px] sm:h-[75px]"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors?.firstName}
                  touched={touched?.firstName}
                />
                <TextInput
                  Icon={person}
                  name={"lastName"}
                  value={values?.lastName || ""}
                  placeholder={"Last Name"}
                  inputClass={
                    "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
                  }
                  iconAreaClass={
                    "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
                  }
                  innerDivClass={"h-[45px] sm:h-[55px]"}
                  inputDivClass={"h-[70px] sm:h-[75px]"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors?.lastName}
                  touched={touched?.lastName}
                />

                {showEmailField && (
                  <div className="w-full flex flex-col h-[70px] sm:h-[75px]">
                    <div className="relative flex h-[45px] sm:h-[55px]">
                      <div className="flex justify-center items-center w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]">
                        <img
                          src={emailIcon}
                          alt=""
                          className="w-5 h-5 sm:w-7 sm:h-7 object-contain"
                        />
                      </div>
                      <input
                        type="email"
                        value={emailValue}
                        readOnly
                        className="flex-1 w-full outline-none text-[12px] md:text-[14px] font-[400] font-poppins rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] bg-[#FAFAFA] pl-[3%] text-[#767676]"
                      />
                    </div>
                    <div className="min-h-[10px] sm:min-h-[10px] md:min-h-[12px]" />
                  </div>
                )}

                {showPhoneField && phoneFieldVariant === "member-invite" && (
                  <div className="w-full flex flex-col h-[70px] sm:h-[75px]">
                    <PhoneFormInput
                      name="phone"
                      country={values?.phoneCountry}
                      countryFieldName="phoneCountry"
                      value={values?.phone || ""}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      error={errors?.phone}
                      touched={touched?.phone}
                      placeholder="Contact Number"
                      divClassName="w-full h-full"
                      containerClass="member-invite-phone !w-full"
                      inputClass="member-invite-phone-input !w-full !rounded-[5px] !border !border-[#D9D9D9] !pr-[16px] !font-poppins !text-[12px] md:!text-[14px] !text-[#767676] !bg-white"
                      buttonClass="member-invite-phone-button"
                      inputStyle={{
                        width: "100%",
                        border: "1px solid #D9D9D9",
                        borderRadius: "5px",
                        paddingRight: "16px",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "14px",
                        color: "#767676",
                        background: "#FFFFFF",
                      }}
                    />
                    <div className="min-h-[10px] sm:min-h-[10px] md:min-h-[12px]" />
                  </div>
                )}

                {showPhoneField && phoneFieldVariant !== "member-invite" && (
                  <PhoneFormInput
                    name="phone"
                    value={values?.phone || ""}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    error={errors?.phone}
                    touched={touched?.phone}
                    placeholder="Contact Number"
                    divClassName="w-full"
                    containerClass="w-full"
                    inputClass="!w-full !h-[45px] sm:!h-[55px] !rounded-[5px] !border !border-[#D9D9D9] !pl-[52px] !font-poppins !text-[12px] md:!text-[14px]"
                    buttonClass="!rounded-l-[5px] !border !border-[#D9D9D9] !bg-[#E6E6E6]"
                  />
                )}

                <TextInput
                  Icon={passwordIcon}
                  type={showPassword ? "text" : "password"}
                  name={"password"}
                  value={values?.password || ""}
                  placeholder={"Password"}
                  inputClass={
                    "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
                  }
                  iconAreaClass={
                    "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
                  }
                  innerDivClass={"h-[45px] sm:h-[55px]"}
                  inputDivClass={"h-[70px] sm:h-[75px]"}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  error={errors?.password}
                  touched={touched?.password}
                  showPassword={showPassword}
                  togglePassword={togglePassword}
                  autoComplete={"new-password"}
                />
                {!hideConfirmPassword && (
                  <TextInput
                    Icon={passwordIcon}
                    type={showConfirmPassword ? "text" : "password"}
                    name={"confirmPassword"}
                    value={values?.confirmPassword || ""}
                    placeholder={"Confirm Password"}
                    inputClass={
                      "w-full rounded-tr-[5px] rounded-br-[5px] border border-[#D9D9D9] pl-[3%]"
                    }
                    iconAreaClass={
                      "w-[11%] bg-[#E6E6E6] rounded-tl-[5px] rounded-bl-[5px] border border-[#D9D9D9]"
                    }
                    innerDivClass={"h-[45px] sm:h-[55px]"}
                    inputDivClass={"h-[70px] sm:h-[75px]"}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    error={errors?.confirmPassword}
                    touched={touched?.confirmPassword}
                    showPassword={showConfirmPassword}
                    togglePassword={toggleConfirmPassword}
                    autoComplete={"new-password"}
                  />
                )}
                <p className="text-[11px] sm:text-[12px] md:text-[14px] font-poppins font-[400] mt-2 text-start w-[95%] leading-tight">
                  By clicking 'Create Account', I agree to the
                  <span
                    className="text-[#00ADEF] font-[500] cursor-pointer"
                    onClick={() => window.open("https://swoodle.com.au/terms-and-conditions/", "_blank")}
                  >
                    {" "}
                    Terms of Use{" "}
                  </span>
                  that I have read the
                  <span
                    className="text-[#00ADEF] font-[500] cursor-pointer"
                    onClick={() => window.open("https://swoodle.com.au/privacy-policy/", "_blank")}
                  >
                    {" "}
                    Privacy Policy.
                  </span>
                </p>
              </>
            )}
          </div>
          {showSubmitButton && (
            <div className="text-center w-full">
              <PrimaryButton
                type={"submit"}
                className={
                  "w-[85%] sm:w-[50%] md:w-[40%] lg:w-[50%] font-poppins text-[12px] sm:text-[14px] lg:text-[16px] text-center font-[500] h-[40px] sm:h-[45px] md:h-[50px] lg:h-[55px] rounded-[10px] my-6 sm:my-10 tracking-wide"
                }
                label={submitLabel}
                disabled={submitDisabled}
              />
            </div>
          )}
        </div>
      </>
    </form>
  );
};

export default MerchantAccountSetupForm;
